import { Box } from "@mui/material";
import InternationalCollaboratorMap from "Explore/Components/InternationalCollaboratorMap";
import SectionTitle from "Explore/Components/SectionTitle";
import { useEffect, useState } from "react";
import {
  getInstitutionInternationalCollaboratorsByCountry,
  getInstitutionInternationalCollaboratorsGeneral,
} from "Explore/Services/Institution";
import styles from "./InternationalCollaborators.module.scss";
import { TIME_FILTER_OPTIONS } from "Explore/Config/constraint";
import PublicIcon from "@mui/icons-material/Public";

const InternationalCollaborators = ({ institution_id }) => {
  const [data, setData] = useState({ data: [], isLoading: true });
  const [countries, setCountries] = useState([]);
  const [selectedKeywords, setSelectedKeywords] = useState([]);
  const [timeFilter, setTimeFilter] = useState(TIME_FILTER_OPTIONS[1].value);

  useEffect(() => {
    if (!institution_id) return;
    setData({ data: [], isLoading: true });
    getInstitutionInternationalCollaboratorsGeneral({
      institutionId: institution_id,
      keyword: selectedKeywords,
      timeFilter,
    })
      .then((res) => {
        setData({ data: res?.results || [], isLoading: false });
      })
      .catch(() => {
        setData({ data: [], isLoading: false });
      });
  }, [institution_id, selectedKeywords, timeFilter]);

  return (
    <Box className={styles["container"]}>
      <SectionTitle
        title='Collaborators All Over the World'
        icon={<PublicIcon />}
      />
      <InternationalCollaboratorMap
        data={data.data}
        isLoading={data.isLoading}
        countries={countries}
        setCountries={setCountries}
        selectedKeywords={selectedKeywords}
        setSelectedKeywords={setSelectedKeywords}
        timeFilter={timeFilter}
        setTimeFilter={setTimeFilter}
        fetchFunction={({ id, page, rowsPerPage }) => {
          return getInstitutionInternationalCollaboratorsByCountry({
            institutionId: institution_id,
            country: id,
            keyword: selectedKeywords,
            page,
            rowsPerPage,
            timeFilter,
          });
        }}
      />
    </Box>
  );
};

export default InternationalCollaborators;
